<template>
	<div
		:class='"Question__results_counts__set" + (answerOptionCorrect ? " AnswerOption--correct" : "")'
	>
		<span v-html="answerOptionText"></span>:
		<animated-number
			class="Question__results_counts__set_count"
			:prev-number="0.0"
			:key='"percentageOfTotal-" + answerOptionId'
			:number="attemptsCountForOption"
			:animation-duration="1"
		></animated-number>
	</div>
</template>

<script>
import Vue from "vue";
import AnimatedNumber from "../properties_components/animated_number.vue";
// Other components
import { i18n } from "../utils";

export default {
	mixins: [i18n],
	props: {
		questionId: Number,
		answerOptionId: Number,
		answerOptionText: String,
		answerOptionCorrect: Boolean,
		srvAttemptsCountForOption: Number,
	},
	components: {
		"animated-number": AnimatedNumber,
	},
	data: function () {
		return {
			attemptsCountForOption: this.srvAttemptsCountForOption,
		};
	},
	computed: {
		locale: function () {
			return I18n.locale;
		},
	},
	mounted() {
		pp.vue.bus.$on("answer_attempt-CREATE", this.onIncomingAnswerAttempt);
	},
	beforeDestroy() {
		pp.vue.bus.$off("answer_attempt-CREATE", this.onIncomingAnswerAttempt);
	},
	methods: {
		onIncomingAnswerAttempt(answerAttempt) {
			if (answerAttempt.answer_option.question_id != this.questionId) {
				return;
			}
			if (answerAttempt.answer_option_id == this.answerOptionId) {
				// @ts-expect-error
				this.attemptsCountForOption = this.attemptsCountForOption + 1;
			}
		},
	},
};
</script>
